module.exports = __webpack_public_path__ + "static/media/termopary2kz.27f230ef.pdf";